import { Box, Flex, Text } from 'rebass/styled-components';
import styled from 'styled-components';

import Media from '../../../utils/Media';
import { CustomBlockCard } from '../../components';

const StyledModuleDescription = styled(Text)`
  color: ${props => props.theme.colors.text};
  line-height: 1.5;
  font-size: 1.25rem;

  ${Media({
    marginBottom: ['3rem', null, null, '3.25rem'],
  })}

  ${Media({
    marginBottom: ['3.25rem', null, '2rem', '3.25rem'],
    maxWidth: ['none', null, '60%', '50%'],
  })}
`;

const StyledModuleHeading = styled.h2`
  color: ${props => props.theme.text.heading.color ?? props.theme.colors.text};
  font-weight: ${props => props.theme.customBlockCards.titleFontWeight || 'normal'};
  word-break: break-word;
  font-size: 40px;
  line-height: 1.2;

  ${Media({
    marginBottom: ['1rem', null, null, '0.5rem'],
  })}
`;

const StyledModuleHeadingContainer = styled.div`
  ${Media({
    minHeight: [null, null, null, '7.25rem'],
  })}
`;

const StyledContainer = styled(Box)`
  position: relative;
  max-width: ${props => props.theme.sizes.xl};

  ${Media({
    marginLeft: ['1rem', null, '2rem', '58px'],
    marginRight: ['1rem', null, '2rem', '58px'],
    marginTop: ['56px', null, null, '81px'],
  })};
`;

const StyledColorBox = styled(Box)`
  position: absolute;
  width: calc(591 / 1440 * 100%);
  top: 0px;
  right: 0px;
  background-color: ${props => props.theme.customBlockCards.backgroundColor};
  z-index: -1;

  ${Media({
    height: ['188px', null, '288px', '402px'],
    marginTop: ['0px', null, '95px', '0px'],
    transform: ['translate(15px, -2.125rem)', null, 'translate(59px, -2rem)'],
    width: [`calc(266 / 375 * 100%)`, null, `calc(591 / 1440 * 100%)`],
  })}

  @media screen and (max-width: 1280px) and (min-width: 1024px) {
    height: 350px !important;
    width: calc(691 / 1440 * 100%) !important;
  }
`;

const StyledCardContainer = styled(Flex)`
  align-items: top;
  justify-content: flex-start;
  margin-bottom: 0px;
  width: 100%;
  flex-wrap: wrap;

  ${Media({
    marginBottom: ['1rem', null, null, '0'],
  })}

  ${Media({
    flexWrap: ['wrap', null, null, 'wrap'],
    position: ['relative', null, 'static'],
  })}

  > * {
    margin: 0 8px;
  }

  > *:nth-child(3n + 1) {
    margin-left: 0;
  }

  > *:nth-child(3n + 3) {
    margin-right: 0;
  }

  > *:not(:last-child) {
    ${Media({
      marginBottom: ['1rem', null, '32px', '0'],
    })}
  }
`;

const StyledCustomBlockCard = styled(CustomBlockCard)`
  max-width: none;

  ${Media({
    width: ['100%', null, 'calc(50% - 16px)', 'calc(33.33% - 10.66px)'],
  })}

  &.cards-2 {
    ${Media({
      width: ['100%', null, 'calc(50% - 16px)'],
    })}
  }
`;

const StyledCenteredModuleTitle = styled.div`
  max-width: 650px;
  margin: 0 auto;
  h2 {
    ${Media({
      fontSize: ['40px', null, null, '56px'],
    })}
  }
`;

const StyledModuleHeadingNoDescription = styled.h2`
  color: ${props => props.theme.colors.text};
  font-weight: normal;
  word-break: break-word;

  ${Media({
    fontSize: ['2rem', null, null, '2.5rem'],
    marginBottom: ['3rem', null, null, '3.25rem'],
  })}

  ${Media({
    marginBottom: ['3.25rem', null, '2rem', '3.25rem'],
    maxWidth: ['none', null, '60%', '50%'],
  })}
`;

export {
  StyledCardContainer,
  StyledCenteredModuleTitle,
  StyledColorBox,
  StyledContainer,
  StyledCustomBlockCard,
  StyledModuleDescription,
  StyledModuleHeading,
  StyledModuleHeadingContainer,
  StyledModuleHeadingNoDescription,
};
